export const TRANSLATIONS_DE = {
  "routes_Pages": "Seiten",
  "routes_Dashboard": "Armaturenbrett",
  "routes_Questionnaire": "Standards",
  "routes_Stats": "Statistiken",
  "routes_Settings": "Einstellungen",
  "routes_Resouces": "Ressourcen",
  "routes_Contact": "Kontakt",
  "routes_Downloads": "Downloads",
  "routes_Documentation": "Dokumentation",
  "dashboard_welcome_message": "Willkommen beim Dashboard des Barrierefreiheitsmanagementsystems 👋",
  "dashboard_label": "Alle Ihre Barrierefreiheitsdaten werden an einem Ort gesammelt, strukturiert und überwacht.",
  "gettingStartedCard_gettingStarted": "Erste Schritte",
  "gettingStartedCard_gettinStartedDescription": "Lorem ipsum dolor sit amet, consectetur adipiscing elit. Nullam elementum dui nunc, ac porta sem consequat nec. Pellentesk",
  "gettingStartedCard_Steps": "Wir empfehlen diese Schritte für den Anfang:",
  "gettingStartedCard_step1": "Lesen Sie die Dokumentation",
  "gettingStartedCard_step2": "Laden Sie die Checkliste herunter",
  "gettingStartedCard_step3": "Überprüfen Sie Ihre Statistiken",
  "companyCard_supportedStandards": "Unterstützte Standards:",
  "companyCard_companyInformation": "Firmeninformation",
  "companyCard_numberOfEmployees": "Mitarbeiter",
  "propertyListPage_propertyList": "Immobilienliste",
  "propertyListPage_dashboard": "Armaturenbrett",
  "propertyListPage_Questionnaire": "Standards",
  "propertyListPage_newProperty": "Neue Immobilie",
  "propertyListPage_textmapEdit": "Eigenschaft bearbeiten",
  "propertyListPage_textmapQuestionnaire": "Klassifizieren",
  "propertyListPage_textmapFacility": "Einrichtung bearbeiten",
  "propertyListPage_textmapNewProperty": "Neue Immobilie",
  "propertyListPage_createNewProperty": "Neue Eigenschaft erstellen",
  "propertyListPage_disabilityClassification": "Behinderungseinstufung",
  "propertyListPage_editProperty": "Eigenschaft bearbeiten",
  "propertyListPage_editFacilities": "Einrichtungen bearbeiten",
  "propertyListPage_classify": "Klassifizieren",
  "propertyListPage_search": "Suche nach Immobiliennamen",
  "propertyForm_propertyInformation": "1.1 Immobilieninformationen",
  "propertyForm_standardType": "Standard-Typ",
  "propertyForm_fieldCannotBeChanged": "Dieses Feld kann nicht geändert werden",
  "propertyForm_propertyCategory": "Immobilienkategorie",
  "propertyForm_typeOfProperty": "Art des Vermögens",
  "propertyForm_propertyName": "Name des Anwesens",
  "propertyForm_propertyArea": "Quadratmeter Bodenfläche",
  "propertyForm_enterPropertyAddress": "1.1.2 Geben Sie die Adresse der Immobilie ein",
  "propertyForm_addressLocation": "Geben Sie unten den Adressort ein",
  "propertyForm_mapNote": "Bei Bedarf können Sie die Karte anpassen, sodass sich die Stecknadel an der richtigen Stelle befindet",
  "propertyForm_keyPropertyData": "1.2 Eckdaten zu den Eigenschaften",
  "propertyForm_floorsQuestion": "Wie viele Etagen hat Ihre Immobilie?",
  "propertyForm_roomsQuestion": "Wie viele Zimmer hat Ihre Immobilie?",
  "propertyForm_disabledRoomsQuestion": "Wie viele behindertengerechte Zimmer gibt es in Ihrer Unterkunft?",
  "propertyForm_alergyRoomsQuestion": "Wie viele Allergikerzimmer gibt es in Ihrer Unterkunft?",
  "propertyForm_save": "Speichern",
  "propertyForm_propertyHotelTypeOptionsLabel_Hotel": "Hotel",
  "propertyForm_propertyHotelTypeOptionsLabel_Motel": "Motel",
  "propertyForm_propertyConvenienceStoreOptions_Candies": "Süßigkeiten",
  "propertyForm_propertyConvenienceStoreOptions_Newspapers": "Zeitungen",
  "propertyForm_propertyConvenienceStoreOptions_TobaccoProducts": "Tabakwaren",
  "propertyForm_propertyConvenienceStoreOptions_Toiletries": "Toilettenartikel",
  "propertyForm_propertyConvenienceStoreOptions_Store": "Speichern",
  "propertyForm_propertyConvenienceStoreOptions_Supermarket": "Supermarkt",
  "propertyForm_propertyDepartmentStoreOptions_Clothing": "Kleidung",
  "propertyForm_propertyDepartmentStoreOptions_DepartmentStore": "Kaufhaus",
  "propertyForm_propertyDepartmentStoreOptions_Electronics": "Elektronik",
  "propertyForm_propertyDepartmentStoreOptions_Garden": "Garten",
  "propertyForm_propertyDepartmentStoreOptions_Household_goods": "Haushaltsgegenstände",
  "propertyForm_propertyDepartmentStoreOptions_Pets": "Haustiere",
  "propertyForm_propertyDepartmentStoreOptions_Toys": "Spielzeuge",
  "propertyForm_propertyFoodAndDrinkOptions_bakery_and_baked_goods_store": "Bäckerei und Backwarenladen",
  "propertyForm_propertyFoodAndDrinkOptions_dairy_goods": "Milchwaren",
  "propertyForm_propertyFoodAndDrinkOptions_food_and_drink": "Essen und Trinken",
  "propertyForm_propertyFoodAndDrinkOptions_food_beverage_specialty_store": "Fachgeschäft für Lebensmittel und Getränke",
  "propertyForm_propertyFoodAndDrinkOptions_grocery": "Lebensmittelgeschäft",
  "propertyForm_propertyFoodAndDrinkOptions_meat": "Fleisch",
  "propertyForm_propertyFoodAndDrinkOptions_specialty_food_store": "Fachgeschäft für Lebensmittel",
  "propertyForm_propertyFoodAndDrinkOptions_Vegan": "Vegan",
  "propertyForm_propertyFoodAndDrinkOptions_Vegetarian": "Vegetarier",
  "propertyForm_propertyFoodAndDrinkOptions_wine_and_liquor": "Wein und Spirituosen",
  "propertyForm_propertyDrugstoreOptions_drugstore": "Drogerie",
  "propertyForm_propertyDrugstoreOptions_pharmacy": "Apotheke",
  "propertyForm_propertyElectronicsOptions_computer_and_software": "Computer und Software",
  "propertyForm_propertyElectronicsOptions_consumer_electronics_store": "Geschäft für Unterhaltungselektronik",
  "propertyForm_propertyElectronicsOptions_electronics": "Elektronik",
  "propertyForm_propertyElectronicsOptions_entertainment_electronics": "Unterhaltungselektronik",
  "propertyForm_propertyElectronicsOptions_mobile_retailer": "Mobiler Händler",
  "propertyForm_propertyElectronicsOptions_mobile_service_center": "Mobiles Servicecenter",
  "propertyForm_propertyMallOptions_shopping_gallery_mall": "Einkaufszentrum mit Einkaufsgalerie",
  "propertyForm_propertyMallOptions_shopping_mall": "Einkaufszentrum",
  "propertyForm_standardTypeOptions_hotel_motel": "Hotel/Motel",
  "propertyForm_standardTypeOptions_shopping_mall": "Einkaufszentrum",
  "propertyForm_standardTypeOptions_shop": "Geschäft",
  "propertyForm_propertyHardwareOptions_floor_and_carpet": "Boden und Teppich",
  "propertyForm_propertyHardwareOptions_furniture_store": "Möbelgeschäft",
  "propertyForm_propertyHardwareOptions_garden_center": "Garten Zentrum",
  "propertyForm_propertyHardwareOptions_glass_and_window": "Glas und Fenster",
  "propertyForm_propertyHardwareOptions_hardware_house_garden": "Hardware-Hausgarten",
  "propertyForm_propertyHardwareOptions_home_improvement_hardware_store": "Baumarkt für Heimwerkerbedarf",
  "propertyForm_propertyHardwareOptions_home_specialty_store": "Fachgeschäft für zu Hause",
  "propertyForm_propertyHardwareOptions_lumber": "Holz",
  "propertyForm_propertyHardwareOptions_major_appliance": "Großgerät",
  "propertyForm_propertyHardwareOptions_paint_store": "Farbengeschäft",
  "propertyForm_propertyHardwareOptions_power_equipment_dealer": "Händler für Elektrogeräte",
  "propertyForm_propertyBookstoreOptions_bookstore": "Buchhandlung",
  "propertyForm_propertyClothingOptions_childrens_apparel": "Kinderbekleidung",
  "propertyForm_propertyClothingOptions_clothing_and_accessories": "Kleidung und Accessoires",
  "propertyForm_propertyClothingOptions_mens_apparel": "Männerbekleidung",
  "propertyForm_propertyClothingOptions_shoes_footwear": "Schuhe",
  "propertyForm_propertyClothingOptions_specialty_clothing_store": "Fachgeschäft für Bekleidung",
  "propertyForm_propertyClothingOptions_womens_apparel": "Frauenkleidung",
  "propertyForm_consumerGoodsOptions_adult_shop": "Erotikladen",
  "propertyForm_consumerGoodsOptions_arts_and_crafts_supplies": "Kunst- und Bastelbedarf",
  "propertyForm_consumerGoodsOptions_bicycle_and_bicycle_accessories_shop": "Fahrrad- und Fahrradzubehörgeschäft",
  "propertyForm_consumerGoodsOptions_camping_hiking_shop": "Camping-Wandershop",
  "propertyForm_consumerGoodsOptions_canoe_kayak_shop": "Kanu-Kajak-Shop",
  "propertyForm_consumerGoodsOptions_car_accessories": "Auto Zubehör",
  "propertyForm_consumerGoodsOptions_consumer_goods": "Konsumgüter",
  "propertyForm_consumerGoodsOptions_cross_country_ski_shop": "Langlaufski-Shop",
  "propertyForm_consumerGoodsOptions_florist": "Florist",
  "propertyForm_consumerGoodsOptions_general_merchandise": "Allgemeine Handelswaren",
  "propertyForm_consumerGoodsOptions_gift_antique_art": "Geschenk antiker Kunst",
  "propertyForm_consumerGoodsOptions_hobby_store": "Hobbyladen",
  "propertyForm_consumerGoodsOptions_hunting_fishing_shop": "Jagdfischerei",
  "propertyForm_consumerGoodsOptions_jeweler": "Juwelier",
  "propertyForm_consumerGoodsOptions_market": "Markt",
  "propertyForm_consumerGoodsOptions_motorcycle_accessories": "Motorradzubehör",
  "propertyForm_consumerGoodsOptions_non_store_retailers": "Einzelhändler außerhalb des Ladengeschäfts",
  "propertyForm_consumerGoodsOptions_office_supply_store": "Geschäft für Bürobedarf",
  "propertyForm_consumerGoodsOptions_pawnshop": "Pfandhaus",
  "propertyForm_consumerGoodsOptions_pet_supply": "Haustierbedarf",
  "propertyForm_consumerGoodsOptions_record_cd_video": "CD-Video aufnehmen",
  "propertyForm_consumerGoodsOptions_running_walking_shop": "Lauf-Walking-Shop",
  "propertyForm_consumerGoodsOptions_skate_shop": "Skateboard Geschäft",
  "propertyForm_consumerGoodsOptions_ski_snowboard_shop": "Ski-Snowboard-Shop",
  "propertyForm_consumerGoodsOptions_specialty_store": "Spezialitätengeschäft",
  "propertyForm_consumerGoodsOptions_sporting_goods_store": "Sportwarengeschäft",
  "propertyForm_consumerGoodsOptions_surf_shop": "Surf-Shop",
  "propertyForm_consumerGoodsOptions_tack_shop": "Ausrüstungsladen",
  "propertyForm_consumerGoodsOptions_toy_store": "Spielzeugladen",
  "propertyForm_consumerGoodsOptions_used_second_hand_merchandise_stores": "Gebrauchtwarenläden",
  "propertyForm_consumerGoodsOptions_variety_store": "Sortenladen",
  "propertyForm_consumerGoodsOptions_video_and_game_rental": "Video- und Spieleverleih",
  "propertyForm_consumerGoodsOptions_warehouse_wholesale_store": "Lagergroßhandel",
  "propertyForm_hairAndBeautyOptions_barber": "Barbier",
  "propertyForm_hairAndBeautyOptions_hair_and_beauty": "Haare und Schönheit",
  "propertyForm_hairAndBeautyOptions_hair_salon": "Friseur",
  "propertyForm_hairAndBeautyOptions_nail_salon": "Nagelstudio",
  "propertyForm_hairAndBeautyOptions_make_up_salon": "Make-up-Salon",
  "propertyForm_mallTopCategoryOptions_mall_shopping_complex": "Mall-Einkaufskomplex",
  "propertyForm_accomodationsCategoryOptions_hotel_motel": "Hotel/Motel",
  "propertyForm_shopCategoryOptions_convenience_store": "Gemischtwarenladen",
  "propertyForm_shopCategoryOptions_department_store": "Kaufhaus",
  "propertyForm_shopCategoryOptions_food_and_drink": "Essen und Trinken",
  "propertyForm_shopCategoryOptions_drugstore_or_pharmacy": "Drogerie oder Apotheke",
  "propertyForm_shopCategoryOptions_electronics": "Elektronik",
  "propertyForm_shopCategoryOptions_hardware_house_garden": "Hardware-Hausgarten",
  "propertyForm_shopCategoryOptions_bookstore": "Buchhandlung",
  "propertyForm_shopCategoryOptions_clothing_and_accessories": "Kleidung und Accessoires",
  "propertyForm_shopCategoryOptions_consumer_goods": "Konsumgüter",
  "propertyForm_shopCategoryOptions_hair_and_beauty": "Haare und Schönheit",
  "facilitiesForm_standardTypeOptions_hotel_motel": "Hotel/Motel",
  "facilitiesForm_standardTypeOptions_office": "Büro",
  "facilitiesForm_standardTypeOptions_shopping_mall": "Einkaufszentrum",
  "facilitiesForm_standardTypeOptions_shop": "Geschäft",
  "facilitiesForm_selectFacilitiesForDataCollection": "2. Wählen Sie Einrichtungen zur Datenerfassung aus",
  "facilitiesForm_preselectedMandatoryItems": "Die folgenden vorausgewählten Elemente sind obligatorisch",
  "facilitiesForm_mandatoryFacilitiesFor": "Obligatorische Einrichtungen für",
  "facilitiesForm_optionalFacilitiesFor": "Optionale Einrichtungen für",
  "facilitiesForm_standard": "Standard",
  "facilitiesForm_preselectedOptionalItems": "Die folgenden Elemente sind optional",
  "facilitiesForm_faq_mandatoryFacilities": "Was sind Pflichteinrichtungen?",
  "facilitiesForm_faq_AnswerMandatoryFacilities": "Dabei handelt es sich um Standardeinrichtungen, die wir in Immobilien Ihrer Art vorfinden. Um unsere Zugänglichkeitsdaten umfassend zu generieren, müssen diese Einrichtungen bewertet werden. EX der Eingang des Gebäudes",
  "facilitiesForm_faq_optionalFacilities": "Was sind optionale Einrichtungen?",
  "facilitiesForm_faq_AnswerOptionalFacilities": "Dies ist eine nicht erschöpfende Liste von Einrichtungen, die in Ihrer Immobilie vorhanden sein können oder nicht, aber nicht unbedingt zu den Standardeinrichtungen einer Immobilie wie Ihrer gehören. Zum Beispiel ein Spa in einem Hotel oder in einem Einkaufszentrum.",
  "unitForm_helperText_entrance_key": "Eingang",
  "unitForm_helperText_entrance_value": "D. h. Haupteingang oder Nebeneingänge, z. B. über Restaurant oder Gärten",
  "unitForm_helperText_lobby_key": "Empfangshalle",
  "unitForm_helperText_lobby_value": "Das heißt, die Hauptlobby des Anwesens einschließlich Lounge oder Wartebereich",
  "unitForm_helperText_reception_key": "Rezeption/Infoschalter",
  "unitForm_helperText_reception_value": "z. B. Haupt-Check-in-Schalter, Concierge-Schalter, Gepäckaufbewahrungsbereich oder Informationsschalterbereiche",
  "unitForm_helperText_facility_key": "Einrichtung",
  "unitForm_helperText_facility_value": "",
  "unitForm_helperText_parking_key": "Parkplatz und nahe Umgebung",
  "unitForm_helperText_parking_value": "dh Hauptparkplatz und zusätzliche Außenbereiche wie Gärten, Einfahrten, Gehwege",
  "unitForm_helperText_commonAreas_key": "Gemeinschaftsräume",
  "unitForm_helperText_commonAreas_value": "Gemeinsame öffentliche Bereiche des Hotels wie Lobby-Lounge, Korridore usw.",
  "unitForm_helperText_conferenceRoom_key": "Konferenzraum / Besprechungsraum",
  "unitForm_helperText_conferenceRoom_value": "",
  "unitForm_helperText_auditorium_key": "Auditorium",
  "unitForm_helperText_auditorium_value": "Raum im Theaterstil, Kino usw.",
  "unitForm_helperText_diningArea_key": "Essbereich",
  "unitForm_helperText_diningArea_value": "z. B. Hauptrestaurant, Frühstücksbuffetbereich, Lobbybar/Bistro",
  "unitForm_helperText_toiletRoom_key": "Toilettenraum (gemeinsam, geteilt)",
  "unitForm_helperText_toiletRoom_value": "dh Gemeinschafts-WC/-Badezimmer, zugänglich von der Lobby, dem Restaurant oder anderen öffentlichen Bereichen",
  "unitForm_helperText_gym_key": "Fitnessstudio",
  "unitForm_helperText_gym_value": "",
  "unitForm_helperText_spa_key": "Spa",
  "unitForm_helperText_spa_value": "",
  "unitForm_helperText_hospitalityRoom_key": "Zimmertyp „Hospitality“.",
  "unitForm_helperText_hospitalityRoom_value": "D. h. Zimmertyp, z. B. Einzelzimmer, Doppelzimmer, barrierefrei, Familienzimmer usw",
  "unitForm_quantityLabel": "Wählen Sie die Menge",
  "unitForm_locationFaq": "Wo befindet es sich?",
  "unitForm_totalQuantity": "Gesamtmenge",
  "unitForm_floorSelection": "Etage auswählen",
  "unitForm_finishedCreation": "Sind Sie mit dem Erstellen von Einheiten fertig?",
  "unitForm_startClassifying": "Fragebogenaktion!",
  "unitForm_unitData2": "Private Toilette",
  "unitForm_unitData3": "Privates Badezimmer",
  "unitForm_unitData4": "Private Küche",
  "unitForm_unitTypeDetails": "3. Details zum Einheitentyp:",
  "unitForm_unitName": "Geben Sie hier den Namen Ihrer Einheit ein",
  "unitForm_accessibleUnit": "Diese Einheit gilt als barrierefrei",
  "questionUnits_addNewUnit": "Neue Einheit hinzufügen",
  "questionUnits_savedInfo": "Ihre Informationen wurden gespeichert",
  "questionUnits_removedInfo": "Ihre Informationen wurden entfernt",
  "questionUnits_resources": "Ressourcen",
  "questionUnits_uploadPictures": "Lade Bilder hoch",
  "questionUnits_explanation": "Einige Erläuterungen/Details zu diesem Abschnitt finden Sie hier",
  "questionUnits_uploadLabel": "HOCHLADEN",
  "questionUnits_unitExtraInfo": "Zusätzliche Informationen zur Einheit",
  "questionUnits_unitExtraInfoPlaceholder1": "Hier können Sie private Kommentare zu dieser bestimmten Einheit einfügen",
  "questionUnits_unitExtraInfoPlaceholder2": "(Derzeit haben Sie keine Kommentare zu diesem Gerät)",
  "questionUnits_beforeClassification": "Sie sollten Einrichtungen hinzufügen, bevor Sie mit der Klassifizierung beginnen",
  "questionUnits_editFacilities": "Einrichtungen bearbeiten",
  "questionUnits_addNew": "Klicken Sie auf „Neu hinzufügen“ oder wählen Sie eine Einheit aus, um mit der Klassifizierung zu beginnen",
  "questionUnits_faq1": "Die Info",
  "questionUnits_faq2": "Was sind Pflichteinrichtungen?",
  "questionUnits_faq2_1": "Dabei handelt es sich um Standardeinrichtungen, die wir in Immobilien Ihrer Art vorfinden. Um unsere Zugänglichkeitsdaten umfassend zu generieren, müssen diese Einrichtungen bewertet werden. EX der Eingang des Gebäudes",
  "questionUnits_faq3": "Was sind optionale Einrichtungen?",
  "questionUnits_faq3_1": "Dies ist eine nicht erschöpfende Liste von Einrichtungen, die in Ihrer Immobilie vorhanden sein können oder nicht, aber nicht unbedingt zu den Standardeinrichtungen einer Immobilie wie Ihrer gehören. Zum Beispiel ein Spa in einem Hotel oder in einem Einkaufszentrum.",
  "FAR_SelectProperty": "Wählen Sie Eigenschaft aus",
  "FAR_DocumentPreview": "Dokumentvorschau:",
  "FAR_DownloadPDF": "PDF Herunterladen:",
  "FAR_Download": "Jetzt downloaden!",
  "CLP_SelectProperty": "Wählen Sie Eigenschaft aus",
  "CLP_SelectPropertyForChecklist": "Wählen Sie eine Immobilie aus, um die Checkliste zu erstellen",
  "CLP_AccessibilityChecklist": "Checkliste zur Barrierefreiheit",
  "CLP_GeneratedOn": "Erstellt am",
  "CLP_GeneratedBy": "Erstellt von",
  "CLP_LoadingDoc": "Dokument wird geladen...",
  "CLP_DownloadNow": "Jetzt downloaden!",
  "A11yUnitsPageSubTitle": "Dinge, die Sie beachten sollten",
  "A11yUnitsPageDescription": "Sie können einander ähnliche Einheiten nur dann zuordnen, wenn sie genau gleich sind. Andernfalls sollte ein anderer Einheitentyp erstellt werden.",
  "routes_NewProperty": "Neue Immobilie",
  "routes_EditProperty": "Eigenschaft bearbeiten",
  "routes_EditFacility": "Einrichtung bearbeiten",
  "routes_SelectFacilities": "Wählen Sie Einrichtungen",
  "routes_CreateProperty": "Eigentum erstellen",
  "routes_Classify": "Klassifizieren",
  "routes_Blank": "Leer",
  "changePassword_success": "Erfolg",
  "changePassword_successMessage": "Dein Passwort wurde aktualisiert",
  "changePassword_returnToLogin": "Zurück zum Login",
  "changePassword_resetPassword": "Setze dein Passwort zurück",
  "changePassword_newPassword_label": "Neues Kennwort",
  "changePassword_confirmNewPassword_label": "Bestätige neues Passwort",
  "changePassword_newPasswordRequired_errorMessage": "Neues Passwort ist erforderlich",
  "changePassword_newPasswordMismatch_errorMessage": "Die Passwörter müssen übereinstimmen",
  "changePassword_newPassword_browserTab": "Kennwort ändern",
  "DocumentationPage_pageTitle": "Dokumentationsseite",
  "DocumentationPage_tabtitle": "Dokumentation",
  "DownloadsPage_pageTitle": "Download-Seite",
  "LanguagesDropdown_English": "Englisch",
  "LanguagesDropdown_French": "Französisch",
  "LanguagesDropdown_German": "Deutsch",
  "LanguagesDropdown_Dutch": "Niederländisch",
  "LocationAutocomplete_searchPlaceholder": "Orte suchen ...",
  "LocationAutocomplete_validAddress": "Bitte geben Sie Hausnummer und Straße an",
  "LocationAutocomplete_addressEmpty": "Die Adresse darf nicht leer sein",
  "page404_PageNotFound": "Seite nicht gefunden.",
  "page404_PageNotFound_explanation": "Die gesuchte Seite wurde möglicherweise entfernt.",
  "page404_PageNotFound_returnHome_button": "Zurück zur Website",
  "page500_InternalError": "Interner Serverfehler.",
  "page500_InternalError_explanation": "Server stötten darauf, dass sie nicht in der Lage sind, die Schlampe zu begehren.",
  "propertyListPage_NotClassified": "Nicht klassifiziert",
  "propertyListIconName_allergy_food_class": "Allergie-Lebensmittelklasse",
  "propertyListIconName_allergy_room_class": "Zimmerklasse für Allergiker",
  "propertyListIconName_mobility_class": "Mobilitätsklasse",
  "propertyListIconName_hearing_class": "Hörklasse",
  "propertyListIconName_cognitive_class": "Kognitive Klasse",
  "propertyListIconName_visual_class": "Visuelle Klasse",
  "propertyForm_AllStepsCompleted": "Alle Schritte abgeschlossen",
  "propertyForm_propertyReady": "Ihre Immobilie ist jetzt fertig!",
  "propertyForm_propertyReady_description": "Sie haben den Schritt Ihrer Immobilieninformationen abgeschlossen. Sie können diese Informationen bearbeiten, indem Sie oben links auf den Link „Eigenschaftenliste“ klicken.",
  "propertyForm_startClassifying": "Beginnen Sie mit der Klassifizierung",
  "propertyForm_propertyStepper_step1": "Immobilieninformationen hinzufügen",
  "propertyForm_propertyStepper_step2": "Wählen Sie Einrichtungen",
  "propertyForm_propertyStepper_step3": "Fügen Sie Einheitendetails hinzu",
  "settingsForms_CompanyInformation_SelectOptions_Service": "Service",
  "settingsForms_CompanyInformation_SelectOptions_Merchandising": "Merchandising",
  "settingsForms_CompanyInformation_SelectOptions_Manufacturing": "Herstellung",
  "settingsForms_CompanyInformation_SelectOptions_Other": "Andere",
  "settingsForms_ImageCantBeChanged": "Dieses Bild kann nicht geändert werden",
  "settingsForms_RegNumber_label": "Registrierungsnummer",
  "settingsForms_InvoiceStatus_label": "Rechnungsstatus",
  "settingsForms_CompanyName_label": "Name der Firma",
  "settingsForms_CompanyType_label": "Unternehmenstyp",
  "settingsForms_CompanySize_label": "Firmengröße",
  "settingsForms_CompanyAddress_label": "Firmenanschrift",
  "settingsForms_ContractDate_label": "Datum der Vertragsunterzeichnung",
  "settingsForms_SubscriptionPeriod_label": "Abonnementzeitraum",
  "settingsForms_Employees_label": "Mitarbeiter",
  "settingsForms_UserInformation_positionOptions_owner": "Eigentümer",
  "settingsForms_UserInformation_positionOptions_executive": "Exekutive",
  "settingsForms_UserInformation_positionOptions_manager": "Manager",
  "settingsForms_UserInformation_positionOptions_operations_and_production": "Betrieb und Produktion",
  "settingsForms_UserInformation_positionOptions_other": "Andere",
  "settingsForms_UserInformation_departmentOptions_it": "ES",
  "settingsForms_UserInformation_departmentOptions_marketing": "Marketing",
  "settingsForms_UserInformation_departmentOptions_finance": "Finanzen",
  "settingsForms_UserInformation_departmentOptions_human_resources": "Personalwesen",
  "settingsForms_UserInformation_departmentOptions_sales": "Verkäufe",
  "settingsForms_UserInformation_departmentOptions_operations": "Operationen",
  "settingsForms_UserInformation_departmentOptions_other": "Andere",
  "settingsForms_UserInformation_title": "Nutzerinformation",
  "settingsForms_UserInformation_UploadPicture": "Bild hochladen",
  "settingsForms_UserInformation_formatRestriction": "Verwenden Sie ein Bild mit mindestens 128 x 128 Pixel im JPG-Format",
  "settingsForms_UserInformation_surname": "Nachname",
  "settingsForms_UserInformation_position": "Position",
  "settingsForms_UserInformation_department": "Abteilung",
  "settingsPage_pageTitle": "Einstellungsseite",
  "settingsPage_breadcrumbs_dashboard": "Armaturenbrett",
  "settingsPage_breadcrumbs_settings": "Einstellungen",
  "signinForm_explanation": "Melden Sie sich bei Ihrem Konto an, um fortzufahren",
  "signinForm_validEmail_error": "Muss eine gültige E-Mail-Adresse sein",
  "signinForm_emailRequired": "E-Mail ist erforderlich",
  "signinForm_generalError": "Etwas ist schief gelaufen",
  "signinForm_passwordRequired": "Passwort wird benötigt",
  "signinForm_emailLabel_textfield": "E-Mail-Adresse",
  "signinForm_passwordLabel_textfield": "Passwort",
  "signinForm_remberMeCheckbox_textfield": "Erinnere dich an mich",
  "signinForm_signIn_button": "anmelden",
  "signinForm_forgotPassword_button": "Passwort vergessen",
  "signupForm_signUp_button": "Melden Sie sich an",
  "signupForm_signUp_title": "Loslegen",
  "signupForm_signUp_subTitle": "Beginnen Sie damit, das bestmögliche Benutzererlebnis für Ihre Kunden zu schaffen",
  "signupForm_signUp_nameRequired": "Name ist erforderlich",
  "signupForm_signUp_minCharacters_errorMessage": "Muss mindestens 12 Zeichen lang sein",
  "signupForm_signUp_required_errorMessage": "Erforderlich",
  "signupForm_signUp_nameLabel": "Name",
  "signupForm_signUp_companyLabel": "Unternehmen",
  "signupForm_signUp_emailAddressLabel": "E-Mail-Adresse",
  "signupForm_signUp_passwordLabel": "Passwort",
  "signupForm_signUp_confirmPasswordLabel": "Bestätige das Passwort",
  "statsPage_pageTitle": "Statistikseite",
  "statsPage_cardContent": "Diese Seite wird in zukünftigen Versionen des Accessibility Management Systems verfügbar sein.",
  "resetPassword_inbox": "Überprüfe deinen Posteingang",
  "resetPassword_explanation_1": "Wir haben eine E-Mail an gesendet",
  "resetPassword_explanation_2": "mit Anweisungen zur Passwortwiederherstellung",
  "resetPassword_title": "Passwort zurücksetzen",
  "resetPassword_subTitle": "Geben Sie Ihre E-Mail-Adresse ein, um Ihr Passwort zurückzusetzen",
  "unitForm_title": "Zusammengesetzte Einheiten",
  "unitForm_floorTitle": "Boden",
  "unitImagesDialog_labelMANDATORY": "OBLIGATORISCH",
  "unitImagesDialog_labelOPTIONAL": "OPTIONAL",
  "unitImagesDialog_labelPICTURES": "BILDER",
  "unitImagesDialog_dropzone": "Legen Sie Bilder hier ab oder wählen Sie eine Datei aus",
  "userDropdown_profile": "Profil",
  "userDropdown_signout": "Abmelden",
  "questionUnits_uploadPictures_uploadError": "Beim Hochladen der Bilder ist ein Fehler aufgetreten",
  "questionUnits_uploadSuccess": "Ihre Daten wurden erfolgreich übermittelt",
  "questionUnits_unitExtraInfoLabel": "Zusatzinformation",
  "questionUnits_unitExtraInfoDelete_button": "Löschen",
  "questionUnits_unitExtraInfoSave_button": "Speichern",
  "QuestionnaireCompletionCard_title": "Fertigstellung der Standards",
  "QuestionnaireCompletionCard_disableMessage": "Sie haben noch keine Klassifizierung.",
  "QuestionnaireCompletionCard_ParkingCard": "Parken",
  "QuestionnaireCompletionCard_EntranceCard": "Eingang",
  "QuestionnaireCompletionCard_ToiletCard": "Toilette",
  "QuestionnaireCompletionCard_RoomsCard": "Räume",
  "QuestionnaireCompletionCard_LiftAndElevatorsCard": "Aufzug und Aufzüge",
  "QuestionnaireCompletionCard_LobbyAndReceptionCard": "Lobby und Rezeption",
  "FAR_Report": "Bericht zur Barrierefreiheit",
  "FAR_TableUnitName": "Einheitenname",
  "FAR_TableDescription": "Beschreibung",
  "CLP_PleaseSelectProperty": "Bitte wählen Sie eine Immobilie aus",
  "CLP_BrowserTabTitle": "Vollständiger Bericht zur Barrierefreiheit",
  "CLP_UnitMandatoryLabel": "Obligatorisch",
  "CLP_UnitDoneLabel": "ERLEDIGT",
  "propertyPage_Controllers_SearchDoc": "Dokumentation durchsuchen",
  "generalWords_Yes": "Ja",
  "generalWords_No": "NEIN",
  "generalWords_Next": "Nächste",
  "generalWords_Close": "Schließen",
  "generalWords_Reset": "Zurücksetzen",
  "generalWords_Back": "Zurück",
  "generalWords_Finish": "Beenden",
  "generalWords_NextStep": "Nächster Schritt",
  "generalWords_Edit": "Bearbeiten",
  "generalWords_Download": "Herunterladen",
  "generalWords_Delete": "Löschen",
  "generalWords_SaveChanges": "Änderungen speichern",
  "generalWords_Selected": "ausgewählt",
  "generalWords_Required": "Erforderlich",
  "customerSupportPage_title": "Kundensupport-Seite",
  "customerSupportPage_emailLabel": "Kontaktieren Sie den Kundendienst unter:",
  "unitForm_helperText_entrance": "D. h. Haupteingang oder Nebeneingänge, z. B. über Restaurant oder Gärten.",
  "unitForm_helperText_lobby": "Das heißt, die Hauptlobby des Anwesens einschließlich Lounge oder Wartebereich.",
  "unitForm_helperText_reception": "z. B. Haupt-Check-in-Schalter, Concierge-Schalter, Gepäckaufbewahrungsbereich oder Informationsschalterbereiche.",
  "unitForm_helperText_facility": "Das heißt, der Name der Einrichtung oder des Grundstücks.",
  "unitForm_helperText_parking": "dh Hauptparkplatz und zusätzliche Außenbereiche wie Gärten, Einfahrten, Gehwege.",
  "unitForm_helperText_conferenceRoom": "Ein Konferenzraum ist ein großer Raum, in dem mehrere Personen eine Konferenz abhalten können.",
  "unitForm_helperText_auditorium": "Raum im Theaterstil, Kino usw.",
  "unitForm_helperText_diningArea": "z. B. Hauptrestaurant, Frühstücksbuffetbereich, Lobbybar/Bistro.",
  "unitForm_helperText_toiletRoom": "dh Gemeinschafts-WC/-Badezimmer, zugänglich von der Lobby, dem Restaurant oder anderen öffentlichen Bereichen.",
  "unitForm_helperText_gym": "Körperliche Übungen und Aktivitäten, die im Innenbereich durchgeführt werden, oft unter Verwendung von Geräten.",
  "unitForm_helperText_spa": "Ort, an dem man sich in der Sauna, im Pool und im Whirlpool entspannen kann.",
  "unitForm_helperText_hospitalityRoom": "D. h. Zimmertyp, z. B. Einzelzimmer, Doppelzimmer, barrierefrei, Familienzimmer usw.",
  "unitForm_helperText_shopping_aisle": "dh Gang zwischen den Regalen.",
  "unitForm_helperText_counter": "Eine ebene Fläche (z. B. ein Tisch, ein Regal oder eine Vitrine), über die Transaktionen durchgeführt werden.",
  "unitForm_helperText_checkout_pay": "z. B. Checkout, Self-Checkout, Self-Scanning-Checkout.",
  "unitForm_helperText_fitting_room": "Ein Raum in einem Geschäft, in dem Kunden ein Kleidungsstück anziehen können, um zu sehen, ob es passt, bevor sie es kaufen.",
  "unitForm_helperText_manned_kiosk": "Ein Geldwechsel- oder Einlöseterminal, das Bargeld- und bargeldlose Transaktionen mit einem Kassierer ermöglicht.",
  "unitForm_helperText_floor": "D. h. die Zugänglichkeit auf verschiedenen Ebenen, z. B. Aufzug auf der 1. Etage, grüner Aufzug am Eingang 2.",
  "unitForm_helperText_playground": "Ein Bereich, der von Kindern zum Spielen genutzt wird. In der Regel gibt es Geräte wie Rutschen, Schaukeln und Wippen, auf denen Kinder spielen können.",
  "unitForm_helperText_garden": "Ein Raum, normalerweise im Freien, der für den Anbau, die Ausstellung und den Genuss von Pflanzen und anderen Formen der Natur reserviert ist.",
  "unitForm_helperText_bathroom_common": "Ein Raum mit einer Badewanne oder Dusche sowie normalerweise einem Waschbecken und einer Toilette.",
  "unitForm_helperText_bathroom__private": "Ein privater Raum mit einer Badewanne oder Dusche sowie normalerweise einem Waschbecken und einer Toilette.",
  "unitForm_helperText_quiet_room": "Ein Ruheraum oder Ruheraum ist ein Raum, der im Hinblick auf Stille gebaut wurde, indem er Lärm von der Umgebung oder gegenüber der Umgebung abschirmt.",
  "unitForm_helperText_kitchen_common": "Ein öffentlicher Raum, in dem man Essen zubereiten und kochen kann.",
  "unitForm_helperText_toilet_room__private": "dh private Toilette, die von der Lobby, dem Restaurant oder anderen öffentlichen Bereichen aus zugänglich ist.",
  "unitForm_helperText_kitchen__private": "Ein privater Raum, in dem man Essen zubereiten und kochen kann.",
  "unitForm_helperText_conferenceRoom_": "",
  "routes_Services": "Dienstleistungen",
  "routes_Help": "Helfen",
  "routes_Clp": "Checkliste",
  "routes_Far": "Bericht zur Barrierefreiheit",
  "FAR_WhatIsItTitle": "Was ist ein Barrierefreiheitsbericht?",
  "FAR_WhatIsItDescription": "Der Barrierefreiheitsbericht ist ein Bericht, den wir für Sie erstellen, je nachdem, wie barrierefrei Ihre Immobilie ist. Unten können Sie eine Immobilie auswählen und deren PDF-Bericht herunterladen.",
  "FAR_MoreInfo": "Weitere Informationen zum Barrierefreiheitsbericht finden Sie hier",
  "FAR_SelectPropertyForChecklist": "Wählen Sie eine Eigenschaft aus, um den Bericht zu erstellen",
  "CLP_noChecklistFound": "Wir konnten keine Liste für diese Immobilie finden",
  "CLP_WhatIsItTitle": "Was ist eine Checkliste?",
  "CLP_WhatIsItDescription": "Die Checkliste ist eine Liste, die auf den Inventarinformationen des Barrierefreiheitssystems basiert. Basierend auf Ihren Eingaben in das System werden die Bereiche angezeigt, in denen Verbesserungen möglich sind. Eine Vorschau des Dokuments ist verfügbar und kann heruntergeladen oder ausgedruckt werden.",
  "CLP_MoreInfo": "Weitere Informationen zur Checkliste finden Sie hier",
  "CLP_FAR_ConsultTheDocumentation": "Konsultieren Sie die Dokumentation",
  "LanguagesDropdown_Swedish": "Schwedisch",
  "LanguagesDropdown_Danish": "dänisch",
  "gettingStartedCard_step1_link": "Lesen",
  "gettingStartedCard_step2_link": "Herunterladen",
  "gettingStartedCard_step3_link": "Überprüfen",
  "contactForm_category": "Kategorie",
  "contactForm_title": "Kontaktiere uns",
  "contactForm_chooseImg": "Bild auswählen",
  "contactForm_submitBtn": "Anfrage senden",
  "contactForm_attachBtnLabel": "Wenn möglich, fügen Sie bitte einen Screenshot bei.",
  "contactForm_messageLabel": "Bitte beschreiben Sie hier Ihr Anliegen.",
  "contactForm_messageEmptyError": "Bitte fügen Sie eine Nachricht hinzu",
  "contactForm_categoryOptions_ServiceInquiry": "Serviceanfrage",
  "contactForm_categoryOptions_TechnicalIssues": "Technische Probleme",
  "contactForm_categoryOptions_OtherInquires": "Sonstige Anfragen",
  "contactForm_subtitle1": "Wenn Sie die Antwort, nach der Sie suchen, nicht finden können, sind wir hier, um Ihnen zu helfen.",
  "contactForm_subtitle2": "Bitte schreiben Sie uns! Wir werden uns schnellstmöglich bei Ihnen melden.",
  "FAR_noDataAvalible_1": "Für diese Eigenschaft kann noch kein Bericht zur Barrierefreiheit erstellt werden. Bitte füllen Sie das aus",
  "FAR_noDataAvalible_2": "für",
  "FAR_noDataAvalible_3": "Erste.",
  "CLP_Updating": "Aktualisierung...",
  "CLP_AreYouSure": "Bist du sicher?",
  "CLP_UpdateMessage": "Wenn Sie dies tun, verschwindet das Element aus der Checkliste und der Standard wird automatisch aktualisiert, um die Änderung widerzuspiegeln.",
  "CLP_Cancel": "STORNIEREN",
  "CLP_YesUpdate": "JA, UPDATE",
  "CLP_WhatIsAChecklist": "Was ist eine Checkliste?",
  "CLP_Name": "Name",
  "CLP_pdfDisclaimer": "Hinweis: Nachdem Sie die Verbesserungen vorgenommen haben, vergessen Sie nicht, Ihre Barrierefreiheitsdaten im Standardbereich zu aktualisieren.",
  "CLP_FAR_noAccessibilityDataAvailable1": "Wir haben keine Daten zur Barrierefreiheit verfügbar.",
  "CLP_noChecklist1": "Die Checkliste kann für diese Eigenschaft noch nicht erstellt werden. Beantworten Sie die darin enthaltenen Fragen",
  "CLP_noChecklist2": "Standardabschnitt",
  "CLP_noChecklist3": "für",
  "CLP_noChecklist4": "Erste.",
  "CLP_FAR_noAccessibilityDataAvailable2": "Erstellen Sie eine Immobilie",
  "CLP_FAR_noAccessibilityDataAvailable3": "und beantworten Sie zunächst die Fragen im Standardteil.",
  "statsPage_subscriptionExpiring": "Das Abonnement läuft in ab",
  "statsPage_days": "Tage",
  "statsPage_contactCustomerSupport": "Kontaktiere den Kundenservice",
  "statsPage_companyInformation": "Firmeninformation",
  "statsPage_numberOfPhotosUploaded": "Anzahl der hochgeladenen Fotos",
  "statsPage_photos": "Fotos",
  "statsPage_totalAmountProperties": "Gesamtzahl der Eigenschaften",
  "statsPage_amountCompleted": "Betrag abgeschlossen",
  "statsPage_actionsPerVisitor": "Aktionen pro Besucher auf dem Widget",
  "statsPage_yourItems": "Ihre Artikel",
  "statsPage_name": "Name",
  "statsPage_sku": "Artikelnummer",
  "statsPage_quantity": "Menge",
  "statsPage_numberOfUnits": "Anzahl der Einheiten",
  "statsPage_accessible": "Zugänglich",
  "statsPage_notAccessible": "Nicht zugänglich",
  "statsPage_unit": "Einheit",
  "statsPage_amount": "Menge",
  "statsPage_incomplete": "Unvollständig",
  "statsPage_completed": "Vollendet",
  "statsPage_notCompleted": "Nicht vollständig",
  "statsPage_mobility": "Mobilität",
  "statsPage_cognitive": "Kognitiv",
  "statsPage_hearing": "Hören",
  "statsPage_visual": "Visuell",
  "statsPage_allergy": "Allergie",
  "statsPage_class": "Klasse",
  "statsPage_totalAccessibilityDatapoints": "Gesamtzahl der Datenpunkte zur Barrierefreiheit",
  "statsPage_visitorsThatOpened": "Besucher, die das Widget geöffnet haben",
  "statsPage_visitorsInteraction": "Gesamtaktionen auf dem Widget",
  "statsPage_action": "Aktion",
  "statsPage_clicks": "Klicks",
  "statsPage_noDataAvailable_topText": "Es liegen keine Daten vor",
  "statsPage_noDataAvailable_bottomText": "Im Augenblick",
  "statsPage_company_address": "Adresse",
  "statsPage_company_city": "Stadt",
  "statsPage_company_country": "Land",
  "statsPage_company_name": "Name",
  "statsPage_company_type": "Typ",
  "statsPage_company_registration_number": "Registrationsnummer",
  "statsPage_company_logo": "Logo",
  "statsPage_company_employees": "Mitarbeiter",
  "statsPage_company_empty_fields": "Leerfelder",
  "settingsPage_alertMsgImageUpload": "Klicken Sie auf Speichern, um Ihr Profilbild zu aktualisieren",
  "settingsPage_alertMsgCompanyInformation_1": "Kontakt",
  "settingsPage_alertMsgCompanyInformation_2": "Kundendienst",
  "settingsPage_alertMsgCompanyInformation_3": "wenn Sie Änderungen an den Unternehmensinformationen vornehmen müssen.",
  "documentationPage_downloadDocument": "Dokument herunterladen",
  "documentationPage_loadingDocument": "Dokument wird geladen",
  "CLP_Status": "Status",
  "CLP_lastUpdate": "Letztes Update",
  "CLP_completed": "vollendet",
  "CLP_incomplete": "unvollständig",
  "LanguagesDropdown_Languages": "Sprachen",
  "login_welcome_message": "Willkommen beim Accessibility Management System 👋",
  "CLP_Checklist_is_generated_based": "Die Checkliste wird auf der Grundlage der Zugänglichkeitsdaten erstellt, die wir von Ihrer Immobilie erfassen. Es zeigt die Verbesserungsbereiche an und sobald Sie den Punkt abgehakt haben, wird die Antwort automatisch im System aktualisiert und Ihre Zugänglichkeitsdaten werden geändert. Das Dokument kann zur externen Verwendung heruntergeladen werden. Für mehr Informationen",
  "CLP_Go_to_checklist": "Gehen Sie zur Checkliste",
  "CLP_Updated_date": "Neues Datum",
  "CLP_The_purpose_of_Handiscover_1": "Der Zweck der Bestandsaufnahme und Checkliste von Handiscover besteht darin, Sie bei der Verbesserung Ihrer Barrierefreiheit zu unterstützen. Die beigefügte Liste besteht aus mehreren Elementen. Unter dem Gesichtspunkt, dass etwas barrierefrei angepasst werden sollte, gibt es Punkte, die zwingend erforderlich sind. Darüber hinaus identifizieren wir Punkte, die wir empfehlen, ob neu gebaut oder renoviert wird.",
  "CLP_List_points": "Punkte auflisten",
  "CLP_Priority": "Priorität",
  "CLP_User": "Benutzer",
  "CLP_Mandatory": "Obligatorisch",
  "CLP_Need_help": "Brauchen Sie Hilfe? Kontaktieren Sie unser Team",
  "CLP_Handiscovers_suggestions": "Vorschläge von Handiscover",
  "propertyForm_nextStep_tooltip": "Füllen Sie zunächst alle erforderlichen Felder aus",
  "statsPage_See_photos": "Siehe Fotos",
  "statsPage_Your_subscription": "Ihr Abonnement",
  "statsPage_Filter_data_from": "Filtern Sie Daten aus",
  "statsPage_Filter_data_to": "Daten filtern nach",
  "statsPage_to": "Zu",
  "statsPage_Reload": "Neu laden",
  "statsPage_Business_Metrics": "Geschäftskennzahlen",
  "statsPage_Service_Metrics": "Servicemetriken",
  "statsPage_Statistics_page": "Statistikseite",
  "imagesPage_Pictures_List": "Bilderliste",
  "imagesPage_Search_by_name": "Suche mit Name",
  "imagesPage_No_pictures_available": "Keine Bilder verfügbar",
  "imagesPage_Name": "Name",
  "imagesPage_Display_in_widget": "Im Widget anzeigen",
  "imagesPage_Type": "Typ",
  "imagesPage_Update_date": "Aktualisierungsdatum",
  "imagesPage_Mandatory": "Obligatorisch",
  "imagesPage_Are_your_sure": "Bist du sicher?",
  "imagesPage_Delete": "Löschen",
  "imagesPage_Yes": "Ja",
  "imagesPage_Cancel": "Stornieren",
  "imagesPage_Open_image": "Bild öffnen",
  "imagesPage_Edit": "Bearbeiten",
  "imagesPage_Delete_image": "Lösche Bild",
  "CLP_The_purpose_of_Handiscover_2": "Wir haben auch Punkte aufgenommen, die „einfach“ zu beheben sind, aber aus Sicht der Barrierefreiheit wahrscheinlich wichtig sind.",
  "a11yUnits_The_title_has_been_translated": "Der Titel wurde übersetzt",
  "statsPage_Statistics": "Statistiken",
  "customerSupportPage_thankYou": "Danke schön!",
  "customerSupportPage_requestSuccessfully": "Ihre Anfrage wurde erfolgreich gesendet. Unser Kundensupport wird sich um Ihr Anliegen kümmern und sich so schnell wie möglich bei Ihnen melden.",
  "customerSupportPage_warning": "Warnung",
  "customerSupportPage_error": "Fehler",
  "propertyListPage_showAll": "Zeige alles",
  "propertyListPage_completed": "Vollendet",
  "propertyListPage_incomplete": "Unvollständig",
  "dashboard": "Armaturenbrett",
  "widget": "Widget",
  "property_type": "Art der Immobilie",
  "category": "Kategorie",
  "edit_widget": "Widget bearbeiten",
  "created": "Erstellt",
  "published": "Veröffentlicht",
  "unpublished": "Unveröffentlicht",
  "widget_info": "Das Barrierefreiheits-Widget zeigt detaillierte Barrierefreiheitsdaten an, die zuvor im Accessibility Management System protokolliert wurden. Mit diesem Widget können Besucher bessere Bedingungen für die Planung ihres Aufenthalts im Voraus schaffen, indem sie die verfügbare Zugänglichkeit sehen. Das Barrierefreiheits-Widget ist interaktiv, da alle im System aktualisierten Daten im Widget wiedergegeben werden.",
  "view_live_widget": "Live-Widget anzeigen",
  "no_widget_data_message": "Wir haben keine Widget-Daten. Bitte wenden Sie sich an unser Kundenservice-Team.",
  "image_list": "Bildliste",
  "language_setting": "Spracheinstellungen",
  "history": "Geschichte",
  "select_accessibility_unit": "Wählen Sie die Einheit Barrierefreiheit aus",
  "add_new_image": "Neues Bild hinzufügen",
  "order": "Befehl",
  "image": "Bild",
  "description": "Beschreibung",
  "accessibility_unit": "Abteilung für Barrierefreiheit",
  "accessibility": "Barrierefreiheit",
  "displayed_in_widget": "Wird im Widget angezeigt",
  "current_image": "Aktuelles Bild",
  "upload_new_picture": "Neues Bild hochladen",
  "image_description": "Bildbeschreibung",
  "image_order": "Bildreihenfolge",
  "back_to_list": "Zurück zur Liste",
  "no_picture": "Kein Bild",
  "please_write_the_text_in": "Bitte schreiben Sie den Text ein",
  "yes_delete": "JA, LÖSCHEN",
  "delete_warning_text": "Wenn Sie dies tun, verschwindet das Element aus dem Widget und der Standard wird automatisch aktualisiert und spiegelt die Änderung wider.",
  "select_language_the_widget_provide": "Wählen Sie die Sprache aus, die das Widget bereitstellt",
  "changed_by": "Verändert von",
  "activity": "Aktivität",
  "showing": "Zeigt",
  "of": "von",
  "items": "Artikel",
  "questionnaire": "Fragebogen",
  "we_are_showing_followings": "Wir zeigen Folgendes in Ihrem Widget an",
  "we_are_recommended_to_state": "Wir empfehlen, im Widget einige praktische Informationen für Besucher Ihrer Immobilie anzugeben. Wenn Sie es bearbeiten möchten, wenden Sie sich bitte an unseren Kundenservice",
  "select_what_you_want_to_show": "Wählen Sie aus, was Sie im Widget anzeigen möchten",
  "practical_information": "Praktische Information",
  "you_can_add_maximum": "Sie können maximal 3 Sätze hinzufügen",
  "for_the_best_experiences_in_widget": "Für ein optimales Widget-Erlebnis helfen wir Ihnen, wenn Sie weitere Informationen hinzufügen möchten",
  "if_you_do_this_the_item_will_disappear": "Wenn Sie dies tun, verschwindet das Element aus dem Widget",
  "you_can_write_free_texts": "Bei Bedarf können Sie Freitexte verfassen, um die allgemeinen Informationen zu ergänzen. Maximal 40 Zeichen",
  "write_a_new_information": "Schreiben Sie eine neue Information",
  "you_can_drag_and_drop_the_block": "Sie können den Block per Drag-and-Drop verschieben, um die Reihenfolge zu ändern. Bitte aktivieren Sie das Kontrollkästchen, um es im Widget anzuzeigen.",
  "you_can_freely_change_the_images_ordering": "Sie können die Reihenfolge der Bilder per Drag & Drop frei ändern.",
  "preview": "Vorschau",
  "add_point_on_map": "Punkt auf Karte hinzufügen",
  "LanguagesDropdown_Spanish": "Spanisch",
  "LanguagesDropdown_Norwegian": "Norwegisch",
  "LanguagesDropdown_Portuguese": "Portugiesisch",
  "LanguagesDropdown_Ukrainian": "Ukrainisch",
  "main_unit_image": "Bild(er) der Haupteinheit",
  "item_pictures": "Artikelbilder",
  "please_choose_a_main_unit_image": "Bitte wählen Sie ein Bild der Haupteinheit",
  "please_choose_a_item_picture": "Bitte wählen Sie ein Artikelbild",
  "button_settings_updated": "Die Schaltflächeneinstellungen wurden erfolgreich aktualisiert",
  "button_settings_created": "Die Schaltflächeneinstellungen wurden erfolgreich erstellt",
  "button_settings": "Einstellungen der Tasten",
  "webmaster_instruction": "Webmaster-Anleitung",
  "contract_has_expired": "Ihr Vertrag ist ausgelaufen. Das Widget wurde gesperrt. Kontakt zum Support",
  "webmaster_instructions_are_not_available": "Eine Anleitung für Webmaster ist zur Zeit nicht verfügbar. Kontakt zur Unterstützung",
  "create_api_key": "API-Schlüssel für dieses Unternehmen erstellen",
  "standard_instruction": "Standard-Instruktion",
  "google_tag_manager_instruction": "Google Tag Manager-Anleitung"
}